// Libs
import axios from 'axios'
import download from 'downloadjs'
import _ from 'lodash'

// Actions
import { signOut } from '../Deauth/actions'

// Constants
import { formatDate } from '../../constants/others'

// Axios
import { serverAPI } from '../../index'

// Action types
export const CHANGE_MY_CASES_PAGE_LOADING = 'change_my_cases_page_loading'
export const CHANGE_SP_CASES = 'change_sp_cases'
export const CHANGE_TOTAL = 'change_total'
export const CHANGE_STATUS = 'change_status'
export const CHANGE_OFFSET = 'change_offset'
export const CHANGE_PER_PAGE = 'change_per_page'
export const CHANGE_FILTER_VISIBLE = 'change_filter_visible'
export const CHANGE_FILTER_COMPANIES = 'change_filter_companies'
export const CHANGE_FILTER_LAW_FIRMS = 'change_filter_law_firms'
export const CHANGE_FILTER_CREATED_BY = 'change_filter_created_by'
export const CHANGE_FILTER_CLASSIFIERS = 'change_filter_classifiers'
export const CHANGE_FILTER_ARCHIVE_REASONS = 'change_filter_archive_reasons'

// Axios Cancelation
export let fetchSpCasesCancel

export const changeMyCasesPageLoading = loading => {
  return {
    type: CHANGE_MY_CASES_PAGE_LOADING,
    payload: loading,
  }
}

export const changeSpCases = spCases => {
  return {
    type: CHANGE_SP_CASES,
    payload: spCases,
  }
}

export const changeTotal = total => {
  return {
    type: CHANGE_TOTAL,
    payload: total,
  }
}

export const changeOffset = offset => {
  return {
    type: CHANGE_OFFSET,
    payload: offset
  }
}

export const changePerPage = perPage => {
  return {
    type: CHANGE_PER_PAGE,
    payload: perPage
  }
}

export const changeFilterVisible = visible => {
  return {
    type: CHANGE_FILTER_VISIBLE,
    payload: visible
  }
}

export const changeFilterCompanies = companies => {
  return {
    type: CHANGE_FILTER_COMPANIES,
    payload: companies
  }
}

export const changeFilterLawFirms = lawFirms => {
  return {
    type: CHANGE_FILTER_LAW_FIRMS,
    payload: lawFirms
  }
}

export const changeFilterCreatedBy = createdBy => {
  return {
    type: CHANGE_FILTER_CREATED_BY,
    payload: createdBy
  }
}

export const changeFilterClassifiers = classifiers => {
  return {
    type: CHANGE_FILTER_CLASSIFIERS,
    payload: classifiers
  }
}

export const changeFilterArchiveReasons = archive_reasons => {
  return {
    type: CHANGE_FILTER_ARCHIVE_REASONS,
    payload: archive_reasons
  }
}

export const fetchSpCases = (id, action, total, offset, perPage, filter = {}, loading = true, exporting = false) => {
  const pages = total / perPage
  let newOffset = ''
  let newFilter = {}

  if (filter.hasOwnProperty('values')) {
    newFilter = filter.values
  }

  switch (action) {
    case 'first':
      newOffset = 0
      break;
    case 'previous':
      newOffset = offset - perPage
      break;
    case 'next':
      newOffset = offset + perPage > total ? offset : offset + perPage
      break;
    case 'last':
      newOffset = (
        Math.floor(pages) * perPage) === total ?
        (Math.floor(pages) - 1) * perPage :
        Math.floor(pages) * perPage
      break;
    default:
      newOffset = offset
  }

  if (fetchSpCasesCancel) {
    fetchSpCasesCancel()
  }

  let config = {
    cancelToken: new axios.CancelToken(function executor(c) {
      fetchSpCasesCancel = c;
    })
  }

  return dispatch => {
    if (loading) dispatch(changeMyCasesPageLoading({ exporting, visible: true }))
    serverAPI.post('/case', { id, offset: newOffset, perPage, filter: newFilter, exporting }, config)
      .then(response => {
        if (loading) dispatch(changeMyCasesPageLoading({ exporting: false, visible: false }))

        if (exporting) {
          const byteCharacters = atob(response.data.base64);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers)
          const file = new Blob([byteArray], { type: 'application/x-www-form-urlencoded' })

          download(file, 'meus-casos' + '.xlsx', 'application/x-www-form-urlencoded')
        } else {
          dispatch(changeSpCases(response.data.cases))
          dispatch(changeTotal(response.data.total))
          dispatch(changeOffset(newOffset))
        }
      })
      .catch(e => {
        if (axios.isCancel(e)) {
          console.log('Request canceled')
        } else {
          if (loading) dispatch(changeMyCasesPageLoading({ exporting: false, visible: false }))

          switch (e.response.status) {
            case 401:
              dispatch(signOut())
              break
            default:
          }
        }
      })
  }
}

export const fetchFilters = (id) => {
  return dispatch => {
    serverAPI.get('/case/filters')
      .then(response => {
        const { companies, lawFirms, createdBy } = response.data

        const legalDepartment = { label: 'Departamento Jurídico', value: 'None' }

        dispatch(changeFilterCompanies(companies))
        dispatch(changeFilterLawFirms([...lawFirms, legalDepartment]))
        dispatch(changeFilterCreatedBy(createdBy))
      })
      .catch(e => {
        switch (e.response.status) {
          case 401:
            dispatch(signOut())
            break
          default:
        }
      })
  }
}

export const fetchFiltersClassifiers = (companyId = null) => {
  return dispatch => {
    serverAPI.post('/group/classifier', { companyId })
      .then(response => {
        const { data } = response
        const noClassifiers = { label: 'Sem Classificador', value: 'None' }

        const classifiers = _.isEmpty(data) ? [] : [...data, noClassifiers]

        dispatch(changeFilterClassifiers(classifiers))
      })
      .catch(e => {
        switch (e.response.status) {
          case 401:
            dispatch(signOut())
            break
          default:
        }
      })
  }
}

export const fetchFiltersArchiveReasons = () => {
  return dispatch => {
    serverAPI.get('/case/archive-reason/all')
      .then(response => {
        dispatch(changeFilterArchiveReasons(response.data))
      })
      .catch(e => {
        switch (e.response.status) {
          case 401:
            dispatch(signOut())
            break
          default:
        }
      })
  }
}
